import { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';
import Navigation from './Navigation';
import Footer from './Footer';

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      data-testid="scroll-to-top"
      className="fixed bottom-6 right-6 z-40 w-10 h-10 rounded-full bg-[#111] text-white/70 hover:text-white flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110"
      aria-label="Haut de page"
    >
      <ChevronUp size={20} />
    </button>
  );
};

const Layout = ({ children }) => {
  return (
    <>
      <Navigation />
      {children}
      <Footer />
      <ScrollToTop />
    </>
  );
};

export default Layout;
